import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { AppStateService } from '../app-state.service';
import { TypZaznamuTextu } from '../model/typ-zaznamu-textu';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-header-polozka',
    templateUrl: './header-polozka.component.html',
    styleUrls: ['./header-polozka.component.css'],
    standalone: false
})
export class HeaderPolozkaComponent implements OnInit {

  @Input() formularFormGroup: UntypedFormGroup;
  @Input() typ: TypZaznamuTextu;
  @Input() kodJazyk: string;
  @Input() zobrazitCopyButton = false;
  // @Input() zobrazitSwapButton = true;
  zobrazitHelpText = false;

  jazykyFormularaPole: string[] = [];
  jazykFormulara1 = 'SK';
  jazykFormulara2 = '';
  jazykFormulara3 = '';
  existujeVoFormulariJazyk2 = false;
  existujeVoFormulariJazyk3 = false;

  readonly SELECT: number = 3;

  constructor(public appStateService: AppStateService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.jazykyFormularaPole = this.appStateService.jazykyFormulara;
    this.jazykFormulara1 = this.jazykyFormularaPole[0];
    if (this.jazykyFormularaPole.length >= 2) {
      this.jazykFormulara2 = this.jazykyFormularaPole[1];
      this.existujeVoFormulariJazyk2 = true;
    }
    if (this.jazykyFormularaPole.length >= 3) {
      this.jazykFormulara3 = this.jazykyFormularaPole[2];
      this.existujeVoFormulariJazyk3 = true;
    }
  }

  skopirovatTextdoOstatnychJazykov() {
    const nameControlJazyk1 =  'name_'+ this.typ.id + '_' + this.jazykFormulara1;
    const nameControlJazyk2 = 'name_'+ this.typ.id + '_' + this.jazykFormulara2;
    const nameControlJazyk3 = 'name_'+ this.typ.id + '_' + this.jazykFormulara3;
    // console.log('nameJazyk1: ' + nameControlJazyk1);
    // console.log('nameJazyk2: ' + nameControlJazyk2);
    // console.log('nameJazyk3: ' + nameControlJazyk3);

    let textPolozkyJazyk1 = this.formularFormGroup.get(nameControlJazyk1).value;
    // console.log('Text polozky na kopirovanie: ' + textPolozkyJazyk1);
    // let haha = {'name_' + '' :textPolozkySK};

    // v pripade comboboxu skopirujeme text do EN tak,
    // ze nastavime z polozkyCiselnikaJazyk2 polozku na rovnakej pozicii, ako je v SK ciselniku


    if (this.typ.idTypObjektu === this.SELECT) {

      // OPAKOVANE POLOZKY
      if (this.typ.opakovanie === 'A') {
        const formArray = <UntypedFormArray>this.formularFormGroup.get(nameControlJazyk1);
        let poleNaKopirovanieJazyk2 = [];
        let poleNaKopirovanieJazyk3 = [];
        for (let index = 0; index < formArray.length; index++) {
          const polozkaControl = formArray.get(index.toString());
          textPolozkyJazyk1 = polozkaControl.value;

          for (let i = 0; i < this.typ.polozkyCiselnika.length; i++) {
            const polozka = this.typ.polozkyCiselnika[i];
            if (polozka === textPolozkyJazyk1) {
              // kontrolou na rovnaku dlzku poli sa ubezpecime, ze index "i" existuje aj v ciselniku jazyka 2 a 3 a
              // ze ciselniky maju rovnaku velkost, a teda su zrejme prelozene vsetky polozky
              if (this.typ.polozkyCiselnikaJazyk2.length > i) {
                poleNaKopirovanieJazyk2.push(this.typ.polozkyCiselnikaJazyk2[i]);
              }
              if (this.jazykFormulara3 && this.typ.polozkyCiselnikaJazyk3.length > i) {
                poleNaKopirovanieJazyk3.push(this.typ.polozkyCiselnikaJazyk3[i]);
              }
              break;
            }
          }
        }

        // kontrolou na rovnaku dlzku poli sa ubezpecime, ze index "i" existuje aj v ciselniku jazyka 2 a 3 a
        // ze ciselniky maju rovnaku velkost, a teda su zrejme prelozene vsetky polozky
        if (this.typ.polozkyCiselnika.length === this.typ.polozkyCiselnikaJazyk2.length) {
          this.formularFormGroup.patchValue({[nameControlJazyk2] :
            poleNaKopirovanieJazyk2});
        }
        if (this.typ.polozkyCiselnikaJazyk3 && this.typ.polozkyCiselnika.length === this.typ.polozkyCiselnikaJazyk3.length) {
          this.formularFormGroup.patchValue({[nameControlJazyk3] :
            poleNaKopirovanieJazyk3});
        }

      } else {
        let indexRiadkuJazyk1Ciselnika: number = 0;
        for (let i = 0; i < this.typ.polozkyCiselnika.length; i++) {
          const polozka = this.typ.polozkyCiselnika[i];
          if (polozka === textPolozkyJazyk1) {
            indexRiadkuJazyk1Ciselnika = i;
            break;
          }
        }
        if (this.existujeVoFormulariJazyk2 && this.typ.polozkyCiselnika.length === this.typ.polozkyCiselnikaJazyk2.length) {
          this.formularFormGroup.patchValue({[nameControlJazyk2] :
            this.typ.polozkyCiselnikaJazyk2[indexRiadkuJazyk1Ciselnika]});
        }
        if (this.existujeVoFormulariJazyk3 && this.typ.polozkyCiselnika.length === this.typ.polozkyCiselnikaJazyk3.length) {
          this.formularFormGroup.patchValue({[nameControlJazyk3] :
            this.typ.polozkyCiselnikaJazyk3[indexRiadkuJazyk1Ciselnika]});
        }
      }
    } else {
      // OPAKOVANA POLOZKA (pri nie SELECTe)
      if (this.typ.opakovanie === 'A') {
        const formArray = <UntypedFormArray>this.formularFormGroup.get(nameControlJazyk1);
        let poleNaKopirovanieJazyk2 = [];
        let poleNaKopirovanieJazyk3 = [];
        for (let index = 0; index < formArray.length; index++) {
          const polozkaControl = formArray.get(index.toString());
          if (this.existujeVoFormulariJazyk2) {
            poleNaKopirovanieJazyk2.push(polozkaControl.value);
          }
          if (this.existujeVoFormulariJazyk3) {
            poleNaKopirovanieJazyk3.push(polozkaControl.value);
          }
        }
        if (this.existujeVoFormulariJazyk2) {
          this.formularFormGroup.patchValue({[nameControlJazyk2] : poleNaKopirovanieJazyk2});
        }
        if (this.existujeVoFormulariJazyk3) {
          this.formularFormGroup.patchValue({[nameControlJazyk3] : poleNaKopirovanieJazyk3});
        }
      } else {
        if (this.existujeVoFormulariJazyk2) {
          this.formularFormGroup.patchValue({[nameControlJazyk2] : textPolozkyJazyk1});
        }
        if (this.existujeVoFormulariJazyk3) {
          this.formularFormGroup.patchValue({[nameControlJazyk3] : textPolozkyJazyk1});
        }
      }
    }

    // console.log('haha1: ' + this.formularFormGroup.get(nameControlJazyk1).value);
    // console.log('haha2: ' + this.formularFormGroup.get(nameControlJazyk2).value);
    // console.log('haha3: ' + this.formularFormGroup.get(nameControlJazyk3).value);
  }

  getKodAPopis() {
    let result = '';
    switch (this.kodJazyk) {

      case this.jazykFormulara1:
        if (this.typ.kod) {
          result += this.typ.kod + ' ';
        }
        if (this.typ.popis) {
          result += this.typ.popis;
        }
        break;

      case this.jazykFormulara2:
        if (this.typ.kodJazyk2) {
          result += this.typ.kodJazyk2 + ' ';
        }
        if (this.typ.popisJazyk2) {
          result += this.typ.popisJazyk2;
        }
        break;

      case this.jazykFormulara3:
        if (this.typ.kodJazyk3) {
          result += this.typ.kodJazyk3 + ' ';
        }
        if (this.typ.popisJazyk3) {
          result += this.typ.popisJazyk3;
        }
        break;

      default:
        break;
    }

    // ak sa nenasiel ziadny text na vyplnenie, vyplnime nazov textom v jazyku 1
    if (result.length === 0) {

      if (this.typ.kod) {
        result += this.typ.kod + ' ';
      }
      if (this.typ.popis) {
        result += this.typ.popis;
      }

    }

    return result;
  }

  getVysvetlivka() {
    let result : string = null;
    switch (this.kodJazyk) {
      case this.jazykFormulara1:
        result = this.typ.vysvetlivka;
        break;
      case this.jazykFormulara2:
        result = this.typ.vysvetlivkaJazyk2;
        break;
      case this.jazykFormulara3:
        result = this.typ.vysvetlivkaJazyk3;
        break;

      default:
        break;
    }
    return result;
  }

  getDoplnPopisCely() {
    let result : string = null;
    switch (this.kodJazyk) {
      case this.jazykFormulara1:
        result = this.typ.doplnPopisCely;
        break;
      case this.jazykFormulara2:
        result = this.typ.doplnPopisCelyJazyk2;
        break;
      case this.jazykFormulara3:
        result = this.typ.doplnPopisCelyJazyk3;
        break;

      default:
        break;
    }
    return result;
  }

  getKopirovaciButtonTooltip() : string {
    let result = this.translateService.instant('Kopírovať text do') + ' ';
    if (this.jazykFormulara2) {
      result += this.jazykFormulara2;
    }
    if (this.jazykFormulara3) {
      result += ' ' + this.translateService.instant('a') + ' ' + this.jazykFormulara3;
    }
    if (this.typ.idSkupina || this.typ.opakovanie === 'A' || this.jazykFormulara3) {
      result += ' ' + this.translateService.instant('položiek');
    } else {
      result += ' ' + this.translateService.instant('položky');
    }
    // + this.jazykFormulara2 + (this.jazykFormulara3 ? ' a ' + this.jazykFormulara3 : '') + this.typ.idSkupina || this.typ.opakovanie ? 'položiek' : 'položky';


    return result;
  }

  presunPolozky(indexPolozky: number, kodJazyk: string) {


    const nameControl1 =  'name_'+ this.typ.id + '_' + kodJazyk;
    // let textPolozkyJazyk1 = this.formularFormGroup.get(nameControl1).value;

    const formArray = <UntypedFormArray>this.formularFormGroup.get(nameControl1);

    // this.formularFormGroup.patchValue({[nameControlJazyk2] : poleNaKopirovanieJazyk2});



  }


}

